import { AddCustomDomainMutation } from 'generated/graphql';
import z from 'zod';

const domain = z
  .string()
  .min(1, "Domain can't be empty")
  .refine(
    (v) => !v.startsWith('http'),
    "Domain shouldn't include https:// protocol, it should look like example.com",
  )
  .refine(
    (v) => v.includes('.'),
    "Domain should include '.' symbol, it should look like example.com",
  );

export const domainForm = z
  .object({
    domain,
    repeatDomain: domain,
    subdomain: z
      .string()
      .min(1, "Subdomain can't be empty")
      .regex(
        new RegExp(/^[a-z0-9]+$/),
        'Subdomain should contain only lowercase letters and digits',
      ),
    hostingProvider: z.string().min(1, 'Hosting provider must be selected'),
  })
  .superRefine(({ domain, repeatDomain }, ctx) => {
    if (domain !== repeatDomain) {
      ctx.addIssue({
        code: 'custom',
        path: ['repeatDomain'],
        message: `Domain and Repeat Domain must match`,
      });
    }
  });

export type DomainFormType = z.infer<typeof domainForm>;

export type CustomDomainEntity = AddCustomDomainMutation['addCustomDomain'] & {
  additionalInfo?: {
    dnsRecords: string[];
    errorCode?: string;
  };
};
